// extracted by mini-css-extract-plugin
export default {"successBox":"ShopOrderSuccess_successBox--A5v","marginBottom":"ShopOrderSuccess_marginBottom--zkj","image":"ShopOrderSuccess_image--zlp"};